module.exports = __webpack_public_path__ + "img/img (25).6ceb90dd.png";